import domReady from '@wordpress/dom-ready';
import manifest from '../manifest.json';

domReady(async () => {
	const blockSelector = `.js-block-${manifest.blockName}`;
	const itemSelector = `.js-complex-auto-accordion-text-item`;
	const accordionElements = document.querySelectorAll(blockSelector);

	if (!accordionElements.length) {
		return;
	}

	const { ComplexAutoAccordionText } = await import('./complex-auto-accordion-text');

	[...accordionElements].forEach((item) => {
		const accordion = new ComplexAutoAccordionText({
			accordion: item,
			blockSelector,
			itemSelector,
			triggerSelector: `${itemSelector}-trigger`,
			panelSelector: `${itemSelector}-panel`,
			progressbarSelector: `${itemSelector}-progressbar`,
			itemImageSelector: `${itemSelector}-image`,
			imageSelector: `${blockSelector}-image`,
		});

		accordion.init();
	});
});
